<template>

    <tq-loader-container :p_tq-loader_b="true" :p_show-loader_b="!server_questExplore_c" :p_absolute-center_b="true" class="TQ_center TQ_maxWidth_500px">
        <div v-if="server_questExplore_c && false">

            <!-- buy tickets -->
            <fcuc-buy-quest-ticket
                :key="server_questExplore_c.qex_questId_uid"
                class="TQ_verticalAlignTop TQ_width_100p TQ_align_initial TQ_inline "

                :p_system_current-currency_e="store_system_currency_ve.val"
                :ps_lang-code_e="store_system_langCode_ve.val"
                :p_store_agent-id_uid="store_system_agentId_vUid.val"

                :p_quest-explore_c="server_questExplore_c"
                :p_current-user-data_c="server_currentUserData_c"

                :pf_show-share-btns_b="false"

            />

        </div>
    </tq-loader-container>

</template>

<script>

    import {store_var, store_getStateValue_vo, store_setStateValue} from "@/store";
    import FcucBuyQuestTicket from "../../../components/unpure/FcucBuyQuestTicket";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        route_getUrlParams,
    } from "@/router";
    import {serverBig_questExplore_once_f} from "@/scripts/Server/S_ServerFirestore";
    import {FB_QuestExplore} from "../../../../functions/src/shareCode/Share_S_Classes";
    import {
        enum_urlParams
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f,
    } from "@/scripts/Server/S_ServerAuth";
    import TqLoaderContainer from "../../../components/basic/TqLoaderContainer";

    export default {
        name: "v_Player_Store_WhiteLabel",
        components: {
            TqLoaderContainer,
            FcucBuyQuestTicket,
        },
        data(){
            return {

                // server
                server_questExplore_c       : undefined,
                server_currentUserData_c    : undefined,

                // store
                store_system_currency_ve        : store_getStateValue_vo(store_var.system_currency),
                store_system_langCode_ve        : store_getStateValue_vo(store_var.system_langCode),
                store_system_agentId_vUid       : store_getStateValue_vo(store_var.player_agentId_uid),

                // imports
                ass_strings             : ass_strings,



            }
        },

        // ========= vueLifeCircle ===========
        mounted(){
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (userData_c) => {
                this.server_currentUserData_c = userData_c
                if(userData_c == null){return}
            })
        },
        activated() {

            let agentId = route_getUrlParams(this.$route, enum_urlParams.agentId)

            if(agentId != null){
                store_setStateValue(store_var.player_agentId_uid, agentId)
            }

            let url_questId_s = route_getUrlParams(this.$route, enum_urlParams.questId)

            // check if return to the same page
            if(this.server_questExplore_c && this.server_questExplore_c.qex_questId_uid === url_questId_s){return}

            // 0) clean last order
            this.server_questExplore_c = null;

            // 1) get quest explore
            serverBig_questExplore_once_f(url_questId_s, false, (questExplore_c) => {
                this.server_questExplore_c = new FB_QuestExplore(questExplore_c)
            })
        },

        destroyed(){
            serverAuth_currentUserData_remove_vl_f(this.$options.name)
        }
    }

</script>

<style scoped lang="scss">




</style>